import styled from 'styled-components';
import theme from '../../styles/theme';

const Container = styled.div`
  width: 100%;
  max-width: ${props => props.fluid ? '100%' : '1200px'};
  margin: 0 auto;
  padding: ${props => props.noPadding ? '0' : `0 ${theme.spacing.lg}`};
  
  @media (max-width: ${theme.breakpoints.lg}) {
    max-width: 100%;
    padding: ${props => props.noPadding ? '0' : `0 ${theme.spacing.md}`};
  }
`;

export default Container; 